var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Scrollbars as CustomScrollbars } from '@epi/react-custom-scrollbars';

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars() {
        var _temp, _this, _ret;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleScroll = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Scrollbars.prototype.renderScrollbarTrack = function renderScrollbarTrack(_ref) {
        var style = _ref.style,
            props = _objectWithoutProperties(_ref, ['style']);

        var trackStyle = {
            width: '6px',
            borderRadius: '3px',
            right: '2px',
            bottom: '2px',
            top: '2px'
        };
        return React.createElement('div', _extends({ style: _extends({}, style, trackStyle) }, props));
    };

    Scrollbars.prototype.renderScrollbarThumb = function renderScrollbarThumb(_ref2) {
        var style = _ref2.style,
            props = _objectWithoutProperties(_ref2, ['style']);

        var thumbStyle = {
            borderRadius: 'inherit',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        };
        return React.createElement('div', _extends({ style: _extends({}, style, thumbStyle) }, props));
    };

    Scrollbars.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            CustomScrollbars,
            { ref: function ref(scrollbars) {
                    _this2.scrollbars = scrollbars;
                }, autoHeight: true, autoHeightMax: this.props.height, onScroll: this.handleScroll, renderTrackVertical: this.renderScrollbarTrack, renderThumbVertical: this.renderScrollbarThumb },
            this.props.children
        );
    };

    return Scrollbars;
}(Component);

export default Scrollbars;